import Button from '@mui/material/Button';
import ContentDialog from './ContentDialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import NotesEditor from '../RichTextEditor/NotesEditor';
import React from 'react';
import { setEntryNote } from '../../Utils/Api';

export default function NotesDialog({ note, awardId, entryId, categoryId = null, content, title, diaglogState, setDialogState, handleClose = ()=>{}, handleChange = ()=>{}, handleDelete = ()=>{} }) {
    
    const [state, setState] = React.useState({
        content: content,
    });
    
    awardId = awardId ?? (note && note.awardId) ?? null;
    entryId = entryId ?? (note && note.entryId) ?? null;
    categoryId = categoryId ?? (note && note.categoryId) ?? null;

    title = title ?? (note && note.entryTitle) ?? null;
    content = (state?.content) ? state.content : content ?? (note && note.note) ?? null;

    function _handleChange(e, content) {
        setState({
            ...state,
            content,
        });
        handleChange(e, content);
    }

    function _handleClose(e) {
        handleClose(e, awardId, entryId, state.content, categoryId);
    }

    function _handleDelete(e) {
        _handleChange(e, '');
        setEntryNote({
            awardId,
            entryId,
            categoryId,
            note: '',
        });
        _handleClose(e);

        handleDelete(e, entryId);
    }

    return (
        <ContentDialog state={diaglogState} setState={setDialogState} title={title} subTitle="Notes" handleClose={_handleClose}>
            <NotesDialogContent awardId={awardId} entryId={entryId} categoryId={categoryId} content={content} handleClose={_handleClose} handleChange={_handleChange} handleDelete={_handleDelete} />
        </ContentDialog>
    );
}

function NotesDialogContent({ awardId, entryId, categoryId = null, content, handleClose, handleChange, handleDelete }) {
    return (
        <>
            <DialogContent style={{paddingTop: "1rem"}}>
                <NotesEditor awardId={awardId} entryId={entryId} categoryId={categoryId} content={content} handleChange={handleChange} />
            </DialogContent>
            <DialogActions style={{ padding: ".5rem 1.5rem " }}>
                <Button onClick={handleDelete}>
                    Delete
                </Button>
                <Button onClick={handleClose}>
                    Save and Close
                </Button>
            </DialogActions>
        </>
    );
}